export { TermsOfServiceModal } from "./TermsOfServiceModal";
export { SolomonTermsDocument } from "./SolomonTermsDocument";
export type { TermsSurface, TermsTrigger } from "./TermsOfServiceModal";
